<template>
<div>
<div v-if="isLoading" class="loading">Loading&#8230;</div>


<!-- CHECK IF HAS ERRORS  -->
<div v-if="stud.hasErrors != ''" class="columns is-centered is-gapless is-multiline colBorderThin has-background-danger-light">

    <div class="column is-3">   
        <div class="columns is-multiline is-gapless">      
            <div class="column is-12 has-text-weight-bold is-uppercase">&nbsp;{{stud.student_lNAME}}</div>
            <div class="column is-12 is-size-7 is-uppercase" style="margin-top:-.5em;">&nbsp; {{stud.student_fNAME}}</div>
            
        </div>
    </div>

    <div class="column is-9 is-size-7 colNotes has-text-weight-bold has-text-danger">  
        {{stud.hasErrors}}
    </div>


</div>

<div v-else class="columns is-centered is-gapless is-multiline colBorderThin has-background-light">

<div class="column is-3">   
    <div class="columns is-multiline is-gapless">      
        <div class="column is-12 has-text-weight-bold is-uppercase">&nbsp;{{stud.student_lNAME}}</div>
        <div class="column is-12 is-size-7 is-uppercase" style="margin-top:-.5em;">&nbsp; {{stud.student_fNAME}}</div>
        
    </div>
</div>

<div class="column is-3">   
    <div class="columns is-multiline is-gapless">      
        <div class="column is-12 has-background-white has-text-weight-bold has-text-centered" style=""> {{stud.student_GRPCODE}}&nbsp;</div>
        <div class="column is-12 is-size-7 is-uppercase has-text-centered" style="margin-top:-.5em;">&nbsp; {{stud.student_CodePerm}}</div>
        
    </div>
</div>

<div class="column is-3">   
    <div class="columns is-multiline is-gapless">      
        
        <!-- CHECK IF GROUP  -->
        <div v-if="type=='ICR' || type=='RCS' || type=='CNS'" class="column is-12 is-size-7 has-text-weight-bold has-text-centered" style=""> {{stud.cour_CODE}}</div>

        <div v-else class="column is-12 is-size-7 has-text-weight-bold has-text-centered" style=""> {{stud.student_CreateDate | moment("MMM DD YY")}}</div>


        <!-- CHECK IF SHOW NOTE  -->
        <div v-if="type=='RCS' || type=='CNS'" class="column is-6 is-size-7 has-text-weight-bold has-text-centered colBorderThinRight has-background-white" style=""> {{stud.cs_MARK}}</div>
        <div v-if="type=='RCS' || type=='CNS'" class="column is-6 is-size-7 has-text-weight-bold has-text-centered has-background-white" style=""> {{stud.cs_REMARK}}</div>

    </div>
</div>


<!-- CHECK WHICH BUTTON  DONE / ERROR -->

<div v-if="is_selected" class="column is-3"> 
        <a class="button is-fullwidth has-background-grey-light has-text-black" @click="hop_off_tran_bus()">
            <span class="icon is-small"><i class="fas fa-backspace"></i></span>
        </a> 
</div>
<!-- END CHECKING IF SELECTED  -->


<div v-else-if="status=='PENDING'" class="column is-3 has-background-warning has-text-black has-text-centered">
    <span class="icon is-small mt-3"><i class="fas fa-clock"></i></span>
    <!-- <a class="button is-fullwidth has-background-warning has-text-black" @click="hop_on_tran_bus('A')">
        <span class="icon is-small"><i class="fas fa-clock"></i></span>
    </a>  -->
</div> 

<div v-else-if="status=='NEED'"  class="column is-3"> 
    <a class="button is-fullwidth has-background-info has-text-white"  @click="hop_on_tran_bus('C')">
        <span class="icon is-small"><i class="fas fa-plus-circle"></i></span>
    </a> 
</div>

<div v-else-if="status=='DONE'"  class="column is-3"> 
    <a class="button is-fullwidth has-background-success has-text-white"  @click="hop_on_tran_bus('A')">
        <span class="icon is-small"><i class="fas fa-thumbs-up"></i></span>
    </a> 
</div>

<div v-else-if="status=='ERROR'"  class="column is-3"> 
    <a class="button is-fullwidth has-background-danger has-text-white"  @click="hop_on_tran_bus('C')">
        <span class="icon is-small"><i class="fas fa-plus-circle"></i></span>
    </a> 
</div>
 
<!-- END CHECKING IF NOT SELECTED  -->


<!-- ****    CHECK ERROR    ****  -->
<div v-if="status=='ERROR' && type=='DID'"  class="column is-12 colNotes colBorderThin has-background-danger-light has-text-weight-bold is-size-7"> &nbsp; {{stud.did_message}} </div> 

<div v-if="status=='ERROR' && type=='IPR'"  class="column is-12 colNotes colBorderThin has-background-danger-light has-text-weight-bold is-size-7"> &nbsp; {{stud.ipr_message}} </div> 

<div v-if="status=='ERROR' && type=='ICR'"  class="column is-12 colNotes colBorderThin has-background-danger-light has-text-weight-bold is-size-7"> &nbsp; {{stud.icr_message}} </div> 

<div v-if="status=='ERROR' && type=='RCS'"  class="column is-12 colNotes colBorderThin has-background-danger-light has-text-weight-bold is-size-7"> &nbsp; {{stud.rcs_message}} </div> 

<div v-if="status=='ERROR' && type=='CNS'"  class="column is-12 colNotes colBorderThin has-background-danger-light has-text-weight-bold is-size-7"> &nbsp; {{stud.cns_message}} </div> 


</div>
<!-- END MAIN COL  -->


 





</div>
</template>

<script>
import moment from 'moment';
import { bus } from '@/main'

//, 'sess', 'ann'
export default {
        props: [ 'stud' , 'type' , 'status' , 'selected' ],
        components: {  },

        data() {
            return {


                isLoading:false,
                is_selected: this.selected,
                tran_selected_id: '',
                smokes :'smokes'
            }
        },


  watch: {
    tran_selected_id: function (val) {
      console.log('---- CHANGE ----')
      console.log(val)
    },
    smokes: function (val) {
      console.log('---- CHANGE ----')
      console.log(val)
    },
  }, // END WATCH

mounted() {





}, // END CREATED

methods : { 

// GENERATE ID FOR TRANSACTION -- SAVE TO DB (NEW) 
    randomTran_ID:function() {

        return 'xxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
    });},

// WHAT ABOUT REMOVAL !!!! 
    hop_on_tran_bus:function (op){ 
        this.is_selected=true; 
        this.tran_selected_id = this.type + this.randomTran_ID()
        bus.$emit('hop_on_for_tran', this.stud , this.type , op , this.tran_selected_id );
    },

    hop_off_tran_bus:function () {
        this.is_selected=false;
        bus.$emit('hop_off_for_tran', this.tran_selected_id , this.type);
    },



validate_ipr:function(){


}, // END VALIDATE IPR









}, // END METHODS


}
</script>